import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FormularService } from '../service';

@Component({
  selector: 'fa-kt-formular-detail',
  templateUrl: './formular-detail.component.html',
  styleUrls: ['./formular-detail.component.css'],
})
export class FormularDetailComponent {
  $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Input() set loading(loading: boolean) {
    this.$loading.next(this.$loading.getValue() || loading);
  }
  @Input() height = 'calc(100vh - 324px)';

  constructor(public formular: FormularService) {}
}
